import React from "react";
import classNames from "classnames";
import Tick from "../../svgs/Tick";
import "./styles.scss";

const HomeBannerBenefits = () => (
    <section className="home-banner-benefits home-banner-benefits--light">
        <div className="inner home-banner-benefits__inner">
            <div className="home-banner-benefit home-banner-benefit--one">
                <span className="home-benefit-number">15</span>
                <span className="home-benefit-desc">
                    Countries covered by Orca
                </span>
            </div>
            <div className="home-banner-benefit home-banner-benefit--two">
                <span className="home-benefit-number">315</span>
                <span className="home-benefit-desc">
                    Direct lenders covered by Orca
                </span>
            </div>
            <div className="home-banner-benefit home-banner-benefit--three">
                <span className="home-benefit-number">8</span>
                <span className="home-benefit-desc">
                    Investment positions facilitated by Orca
                </span>
            </div>
            <div className="home-banner-benefit home-banner-benefit--four">
                <span className="home-benefit-number">€33bn</span>
                <span className="home-benefit-desc">
                    Cumulative market origination volumes
                </span>
            </div>
        </div>
    </section>
);

export default HomeBannerBenefits;
